import React from 'react';
import Card from './Card';

function StatItem({ stat }) {
  return (
    <div className="bg-white rounded-xl p-4 border">
      <div className="text-sm text-gray-500">{stat.title}</div>
      <div className="mt-2 flex items-baseline gap-3">
        <div className="text-2xl font-semibold text-gray-800">{stat.value}</div>
        <div className="text-sm text-blue-600">{stat.delta}</div>
      </div>
    </div>
  );
}

export default function StatsGrid({ stats = [] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {stats.map((s) => (
        <div key={s.id} className="bg-white rounded-2xl p-6 shadow-sm border flex items-center justify-between">
          <div>
            <div className="text-sm text-gray-500">{s.title}</div>
            <div className="mt-2 text-2xl font-semibold text-gray-800">{s.value}</div>
          </div>
          <div className="text-sm text-blue-600">{s.delta}</div>
        </div>
      ))}
    </div>
  );
}
